import Vue from 'vue'
import { babel } from '@/packages/vue-i18n'
import { getCurrencyFractionDigits, truncateCurrencyValue } from '@/utils/currency'

Vue.filter('empty', value => value || '-')

Vue.filter('currency', (value, symbol) => {
	let parsedValue = value
	if (parsedValue === null || parsedValue === undefined) {
		return '-'
	}
	const currency = symbol || 'EUR'
	const fractionDigits = getCurrencyFractionDigits(currency, babel.locale)
	const formatOptions = {
		style: 'currency',
		currency,
		minimumFractionDigits: fractionDigits,
		maximumFractionDigits: fractionDigits
	}
	if (typeof parsedValue === 'string') {
		parsedValue = parseFloat(parsedValue.replace(',', '.').replace(' ', ''))
		if (!parsedValue) {
			return new Intl.NumberFormat(babel.locale, formatOptions).format(0)
		}
	}
	return new Intl.NumberFormat(babel.locale, formatOptions)
		.format(truncateCurrencyValue(parsedValue, fractionDigits))
})

Vue.filter('decimal', (value, currencyCode, fractionDigits) => {
	let parsedValue = value
	if (parsedValue === null || parsedValue === undefined) {
		return '-'
	}
	if (typeof parsedValue === 'string') {
		parsedValue = parseFloat(parsedValue.replace(',', '.').replace(' ', ''))
	}
	if (isNaN(parsedValue)) {
		return '-'
	}

	// Get decimal places for the currency
	const currency = currencyCode || 'EUR'
	const decimalPlaces = fractionDigits ?? getCurrencyFractionDigits(currency, babel.locale)

	// Format as decimal with currency-specific decimal places
	return new Intl.NumberFormat(babel.locale, {
		style: 'decimal',
		minimumFractionDigits: decimalPlaces,
		maximumFractionDigits: decimalPlaces
	}).format(truncateCurrencyValue(parsedValue, decimalPlaces))
})

Vue.filter('number', (value) => {
	const parsedValue = Number(value)
	if (value === null || value === undefined || isNaN(parsedValue)) {
		return '-'
	}
	// Avoid rendering "-0" for small negatives that round to zero
	const roundedValue = Math.abs(parsedValue) < 0.5 ? 0 : parsedValue
	return new Intl.NumberFormat(babel.locale, { maximumFractionDigits: 0 }).format(roundedValue)
})

// Get currency symbol from currency code based on current locale
Vue.filter('currencySymbol', (currencyCode) => {
	if (!currencyCode) {
		return '-'
	}

	try {
		const parts = new Intl.NumberFormat(babel.locale, {
			style: 'currency',
			currency: currencyCode
		}).formatToParts(1)

		const currencyPart = parts.find(part => part.type === 'currency')
		return currencyPart ? currencyPart.value : currencyCode
	} catch (_e) {
		// If currency code is invalid, return the code itself
		return currencyCode
	}
})

Vue.filter('engine', (value, isMoto = false) => {
	if (value === 0 || value === null) {
		return '-'
	}

	return parseFloat(value).toFixed(isMoto ? 2 : 1) + ' L'
})

Vue.filter('quantity', data => {
	return `${data} ${babel.t('common.fields.units')}`
})

Vue.filter('time', dateTime => {
	if (dateTime) {
		return `${new Date(dateTime).toLocaleDateString(babel.locale)} ${new Date(dateTime).toLocaleTimeString(babel.locale, { hour: '2-digit', minute: '2-digit' })}`
	}
	return '-'
})

Vue.filter('date', dateTime => {
	if (dateTime) {
		return new Date(dateTime).toLocaleDateString(babel.locale)
	}
	return '-'
})
